import React from 'react';
import './ImageWithButton.scss';
import crossSvg from '../../../icons/cross.svg';
import infoSvg from '../../../icons/info.svg';
import backSvg from '../../../icons/back.svg';

const ImageWithButton = (props) => {
  const icons = {
    help: '',
    info: infoSvg,
    back: backSvg,
  };
  return (
    <div className={`image-with-button ${props.list ? 'image-with-button--list' : ''}`}>
      {props.imgUrl && (
        <div className="image-content">
          <img
            onClick={props.imageCta ? props.ctaAction : ()=>{}}
            alt=""
            style={props.textOverlay ? { opacity: 0 } : {}}
            className={`image-with-button__image ${
              props.useOutline ? 'image-with-button__image--outline' : ''
            } `}
            src={props.imgUrl}
          />

          {props.textOverlay && (
            <div className="image-content__text-overlay">
              {props.titleOverlay && <strong>{props.titleOverlay}</strong>}
              <p>{props.textOverlay}</p>
            </div>
          )}
          <div className="image-content__helpers">
            <button onClick={props.helpAction} className="btn-icon">
              <img height="40" src={icons[props.helpIcon]} />
            </button>
          </div>
        </div>
      )}

      <div className="image-with-button__title">
        {props.titleOverlay?.replace('Soy Wax Melt', '').replace('Fragrance Oil', '')}
      </div>
      <div className="image-with-button__button">
        <button
          onClick={props.ctaAction}
          className={`btn ${
            props.ctaColor ? 'btn--' + props.ctaColor : 'btn--success'
          }`}
        >
          {props.ctaText}
        </button>
      </div>
    </div>
  );
};

export default ImageWithButton;
